module.exports = __webpack_public_path__ + "static/media/musical.cfeee9b3.svg";